import React from 'react';
import { StatementsProvider } from 'context/statements/useStatements';
import { AccountsProvider } from 'context/useAccounts';
import { AuthProvider } from 'context/useAuth';
import { NotificationsProvider } from 'context/useNotification';

import ThemeProvider from './Theme';

export default ({ children }) => (
    <ThemeProvider>
        <AuthProvider>
            <AccountsProvider>
                <StatementsProvider>
                    <NotificationsProvider>{children}</NotificationsProvider>
                </StatementsProvider>
            </AccountsProvider>
        </AuthProvider>
    </ThemeProvider>
);
